export const zipCodePattern = {
	pattern: /^\d{5}-\d{3}$/g,
	message: "Esse campo requer um CEP válido",
};
